export default "__VITE_ASSET__3036b3bc__"